module.exports = __webpack_public_path__ + "static/media/user-interface-design-icon@4x.cafed68e.png";